import { ToothSvgComponentProps } from '@/modules/patientList/patientStrip/patientStripOdontogram/types';

const SvgNormal = (props: ToothSvgComponentProps) => (
  <svg
    width={9 * (props.wx ?? 1)}
    height={26 * (props.hx ?? 1)}
    viewBox="0 0 9 26"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    className={props.className}
  >
    <path
      d="M0.886532 18.8297C0.931697 18.5356 1.00725 17.924 1.27571 17.3622C1.53784 16.8142 1.7911 16.2609 1.88228 15.6716C2.37615 12.4894 2.27316 9.01315 3.3145 5.20454C4.00718 2.67067 4.0515 1.13676 4.53904 1.04801C5.08018 0.949614 5.81296 2.49281 5.86699 5.30517C5.94212 9.24114 6.74666 13.1351 6.93703 15.5762C7.02652 16.7265 7.36252 17.3448 7.45918 17.6489C7.54191 17.9095 7.59764 18.2081 7.63183 18.5478C7.74706 19.6863 7.72131 22.0004 7.62295 23.5918C7.56555 24.5235 7.42837 24.9048 6.67997 24.9657C5.06752 25.0968 2.76027 25.0574 1.31412 24.8851C0.792819 24.8231 0.74723 24.4867 0.732879 23.8714C0.698688 22.3724 0.664925 20.27 0.886532 18.8297Z"
      fill={props.fill || '#E4E4E7'}
      stroke={props.stroke || '#A1A1AA'}
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
);
export default SvgNormal;
